import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '../../Context';
import PopoverOnHover from '../PopoverOnHover';
import TextTooltipContent from '../_partials/TextTooltipContent';
import { Reference } from 'react-popper';
var TextTooltipOnHover = function (_a) {
    var title = _a.title, tooltipText = _a.tooltipText, children = _a.children, tooltipOffset = _a.tooltipOffset, renderTooltipContent = _a.renderTooltipContent, renderReference = _a.renderReference, props = __rest(_a, ["title", "tooltipText", "children", "tooltipOffset", "renderTooltipContent", "renderReference"]);
    var isMobile = useContext(MobileContext);
    if (isMobile) {
        return (React.createElement("span", { className: props.className }, renderReference ? React.createElement(Reference, null, renderReference) : children));
    }
    var content = (React.createElement(TextTooltipContent, { title: title, tooltipText: tooltipText }));
    return (React.createElement(PopoverOnHover, __assign({ popoverContent: content, popoverOffset: tooltipOffset, renderInnerContent: renderTooltipContent, renderReference: renderReference }, props), children));
};
export default TextTooltipOnHover;
//# sourceMappingURL=TextTooltipOnHover.js.map